import { z } from "zod";

/** Width divided by height. A target ratio guides composition; fixed mode also controls the stage frame. */
export const zStoryAspectRatio = z.number().finite().min(0.25).max(4);
export const zStoryFraming = z.discriminatedUnion("mode", [
  z.object({ mode: z.literal("responsive"), aspectRatio: zStoryAspectRatio.optional() }).strict(),
  z
    .object({
      mode: z.literal("fixed"),
      aspectRatio: zStoryAspectRatio,
      allowPanning: z.boolean().optional(),
      allowOrientationChanges: z.boolean().optional(),
    })
    .strict(),
]);
export type StoryFraming = z.infer<typeof zStoryFraming>;

/** How far a camera cue magnifies the artwork; 1 shows the whole camera frame and null returns to it. */
export const MAX_CAMERA_ZOOM = 8;
export const zCameraZoom = z.number().finite().min(1).max(MAX_CAMERA_ZOOM);
/**
 * The artwork point a zoom centres on, 0..1 across and down the picture; an omitted axis is the middle. The stage moves
 * it as little as needed to keep the whole view inside the artwork.
 */
export const zCameraZoomCenter = z
  .object({ x: z.number().finite().min(0).max(1).optional(), y: z.number().finite().min(0).max(1).optional() })
  .strict();
export type CameraZoomCenter = z.infer<typeof zCameraZoomCenter>;

/** An omitted generation setting always starts a responsive composition, including from older fixed camera scenes. */
export function resolveStoryFraming(framing?: StoryFraming): StoryFraming {
  return framing ?? { mode: "responsive" };
}
